//^[0-9]{2}[0-9]{3}-[0-9]{3}$

export default function isCepValid(cep) {
  const pattern = /^[0-9]{2}[0-9]{3}-[0-9]{3}$/;
  if (pattern.test(cep)) return true;
  else return false;
}
